import { Component } from "react";
import { datadogRum } from "@datadog/browser-rum";
import "./RumErrorBoundary.scss";
import TechnicalErrorContainer from "app/pages/TechnicalError/TechnicalErrorContainer";

class RumErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		const renderingError = new Error(error.message);
		renderingError.name = `ReactRenderingError`;
		renderingError.stack = errorInfo.componentStack;
		renderingError.cause = error;

		datadogRum.addError(renderingError);
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return (
				<div className="rum-error-boundary">
					<TechnicalErrorContainer />
				</div>
			);
		}

		return this.props.children;
	}
}

export default RumErrorBoundary;
